<template>
  <div class="inicio">
    <div class="container">
      <head-nav :activeNav="'Inicio'"></head-nav>
      <div class="top">
        <img src="@/assets/image/Inicio/one.png" alt="" />
        <div class="right">
          <p>
            Muchamo es una aplicación de préstamos de crédito en línea en Perú.
            ¡Si necesitan un préstamo con urgencia,si quieren un préstamo más
            sólido, si desean un préstamo con monto más alto, utiliza Muchamo!
            El depósito llega muy rápido menos de 3 minutos. La aplicación
            Muchamo es segura, fácil y flexible. ¡Utiliza Muchamo, les dará una
            experiencia mágica!
          </p>
          <!-- href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/Muchamo_v1.0.9.apk" -->
          <!-- href="https://www.muchamo.com/Muchamo_google_release_v1.0.10_2403191759.apk" -->
          <a href="">
            <img src="@/assets/image/Inicio/playBtn2.png" alt="" />
          </a>
        </div>
      </div>
      <div class="middle">
        <div class="como">
          <div>
            <h1>¿Cómo solicita un préstamo?</h1>
            <div class="flex">
              <img src="@/assets/image/Inicio/three_one.png" alt="" />
              <span>Descarga la aplicación para Android en Google Play</span>
            </div>
            <div class="flex">
              <img src="@/assets/image/Inicio/three_two.png" alt="" />
              <span
                >Rellena sus datos personales para verificar su identidad y
                derecho</span
              >
            </div>
            <div class="flex">
              <img src="@/assets/image/Inicio/three_th.png" alt="" />
              <span>Espera a que el préstamo llega a su cuenta</span>
            </div>
          </div>
          <img src="../assets/image/Inicio/three.png" alt="" />
        </div>
        <div class="option">
          <div>
            <img src="@/assets/image/Inicio/option_one.png" alt="" />
            <p>
              Aprobación en<br />
              3 minutos
            </p>
          </div>
          <div>
            <img src="@/assets/image/Inicio/option_two.png" alt="" />
            <p>Sin gastos ocultos</p>
          </div>
          <div>
            <img src="@/assets/image/Inicio/option_three.png" alt="" />
            <p>
              La tasa de interés<br />
              es baja
            </p>
          </div>
          <div>
            <img src="@/assets/image/Inicio/option_four.png" alt="" />
            <p>
              El monto de préstamo<br />
              es alto
            </p>
          </div>
        </div>
        <div class="descarga">
          <p>
            ¡Descarga la aplicación y le dará una<br />
            experiencia mágica!
          </p>
          <!-- href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/Muchamo_v1.0.9.apk" -->
          <!-- href="https://www.muchamo.com/Muchamo_google_release_v1.0.10_2403191759.apk" -->
          <a href="">
            <img src="@/assets/image/Inicio/playBtn3.png" alt="" />
          </a>
        </div>
        <div class="necesitas">
          <p>
            ¡Si tiene más dudas, conversa con nosotros sin<br />
            compromiso, le responderemos con prontitud!
          </p>
          <div>
            <div>
              <img src="../assets/image/Inicio/necesitas_one.png" alt="" />
              <div class="title">
                <h5>Atención al Cliente:</h5>
                <h6>+51 {{ phone }}</h6>
              </div>
            </div>
            <div>
              <img src="../assets/image/Inicio/necesitas_two.png" alt="" />
              <div class="title">
                <h5>WhatsApp:</h5>
                <h6>+51 {{ whatsApp }}</h6>
              </div>
            </div>
            <div>
              <img src="../assets/image/Inicio/necesitas_three.png" alt="" />
              <div class="title">
                <h5>Email:</h5>
                <h6>support@muchamo.com</h6>
              </div>
            </div>
            <div>
              <img src="../assets/image/Inicio/necesitas_four.png" alt="" />
              <div class="title">
                <h5>Horario de Atención:</h5>
                <h6>
                  LUN-VIER 9:00 A 18:00,<br />
                  SAB 9:00 A 14:40
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot-page></foot-page>
  </div>
</template>

<script>
import footPage from "../components/footPage.vue";
import headNav from "../components/headNav.vue";
export default {
  name: "Inicio",
  components: {
    headNav,
    footPage,
  },
  data() {
    return {
      whatsApp: "",
      phone: "",
    };
  },
  created() {
    this.getInformation();
  },
  methods: {
    getInformation() {
      if (localStorage.getItem("customerData") !== "undefined") {
        const data = JSON.parse(localStorage.getItem("customerData"));
        this.whatsApp = data.customerServiceWhatsApp.whatsApp;
        this.phone = data.customerServicePhone.phone;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.inicio {
  width: 100%;
  background: #03040c;
  background-size: 100% 100%;
  position: relative;
  .container {
    width: 1200px;
    margin: 0 auto;
    .top {
      display: flex;
      justify-content: space-between;
      padding: 48px 0 40px;
      box-sizing: border-box;
      img {
        width: 430px;
        height: 430px;
        margin-right: 154px;
      }
      .right {
        p {
          font-size: 32px;
          font-family: LucidaGrande-Bold, LucidaGrande;
          font-weight: bold;
          color: #e8e8e9;
          line-height: 40px;
          margin-bottom: 40px;
        }
        img {
          width: 290px;
          height: 87px;
        }
      }
    }
    .middle {
      .como {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #e8e8e9;
          margin-bottom: 40px;
        }
        .flex {
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          img {
            width: 42px;
            margin-right: 22px;
          }
          span {
            font-size: 22px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            color: #e8e8e9;
          }
        }
        img {
          width: 512px;
        }
      }
      .option {
        display: flex;
        justify-content: center;
        margin: 100px 0;
        box-sizing: border-box;
        div {
          width: 254px;
          height: 250px;
          background: linear-gradient(180deg, #7c47e9 0%, #5d52dd 100%);
          margin-right: 60px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: stretch;
          padding-top: 40px;
          box-sizing: border-box;
          border-radius: 15px;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 109px;
            height: 109px;
            margin-bottom: 20px;
          }
          p {
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            text-align: center;
          }
        }
      }
      .descarga {
        width: 100%;
        height: 362px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #1e1f30;
        position: absolute;
        left: 0;
        p {
          font-size: 40px;
          font-family: Arial-Black, Arial;
          font-weight: 900;
          color: #e8e8e9;
          line-height: 52px;
          text-align: center;
        }
        img {
          width: 378px;
          height: 113px;
          margin-top: 40px;
        }
      }
      .necesitas {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 48px 0 112px;
        box-sizing: border-box;
        margin-top: 505px;
        p {
          text-align: center;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #e8e8e9;
          line-height: 52px;
        }
        > div {
          display: flex;
          margin-top: 60px;
          width: 100%;
          justify-content: space-between;
          div {
            display: flex;
            align-items: flex-start;
            img {
              width: 62px;
              height: 62px;
              margin-right: 14px;
            }
            .title {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #e8e8e9;
              margin-top: 5px;
              h5 {
                font-size: 18px;
              }
              h6 {
                font-size: 16px;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
